import * as React from "react";
import { Grid, Typography } from "@material-ui/core";
import { useFormikContext } from "formik";
import { Label } from "../../../components/formInputs";
import {
    DatePicker,
    ErrorHelper,
    PhoneNumberField,
    SelectField,
    SSNNumberField,
    TextField,
    TextFieldCommon,
} from "../../formikFormInputs";
import { required } from "../../../utils/validation";
import { AccountType, genderDropDown } from "../../../constants";
import { useSelector } from "react-redux";
import { RootState } from "../../../reducers";
import { AccountStatus } from "../../../model";
import BlotFieldShowHide from "../../formikFormInputs/BlotFieldShowHide";



export default function GiftorPrimaryDetails() {
    const { handleChange, errors, touched, values }: any = useFormikContext();
    const { user } = useSelector((state: RootState) => state.auth);
    const invStatus = (user && user.inviteStatus) as number;
    const enrollmentStartedDisabled = invStatus  >= AccountStatus.EnrollmentStarted;
    const isIndividual = user && user.role === AccountType.Individual;

    const fieldObj = [
        {
            name: "firstName",
            component: TextField,
            placeholder: "enter first name",
            label: <Label label={"First Name"} required={true} />,
            disabled: enrollmentStartedDisabled,
        },
        {
            name: "lastName",
            component: TextField,
            placeholder: "enter last name",
            label: <Label label={"Last Name"} required={true} />,
            disabled: enrollmentStartedDisabled,
        },
        {
            name: "email",
            component: TextField,
            placeholder: "email@domain.com",
            label: <Label label={"Email Address"} required={true} />,
            disabled: enrollmentStartedDisabled,

        },
        {
            name: "phoneNumber",
            component: PhoneNumberField,
            placeholder: "Enter Phone Number",
            label: <Label label={"Cell Phone"} required={true} />,
            disabled: enrollmentStartedDisabled,
        },
        {
            className: "chooseDateField mt0",
            id: "dob",
            label: <Label label={"Date of birth"} required={true} />,
            name: "dob",
            placeholder: "Date of birth",
            component: DatePicker,
            disabled: enrollmentStartedDisabled,
            disableFuture: true,
            validate: required,
        },
        {
            name: "gender",
            id: "gender",
            label: <Label label={"Gender"} required={true} />,
            component: SelectField,
            options: genderDropDown,
            disabled: enrollmentStartedDisabled,
            validate: required,
        },
        {
            name: "employeeSSN",
            id: "employeeSSN",
            label: <Label label={"Social Security Number"} required={true} />,
            component: isIndividual ? SSNNumberField :  BlotFieldShowHide,
            disabled: enrollmentStartedDisabled || !isIndividual,
            filedType: "string",
            variant: "outlined",
            hideSSNButton: !isIndividual,
            formatChars: {
                "9": "[0-9]",
            },
        },
    ];

    return (
            <>
                {/*<link rel="stylesheet" href={`${process.env.PUBLIC_URL}/css/landingPageV2.css`} />*/}

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography variant="h3">
                            Provide your Details (Giftor)
                        </Typography>
                    </Grid>
                    {
                        fieldObj.map((field, index) => (
                                <Grid item xs={12} sm={6} md={6} key={index}>
                                    <TextFieldCommon
                                            {...field}
                                            values={values}
                                            onChange={handleChange}
                                    />
                                    <ErrorHelper errors={errors} name={field.name}/>
                                </Grid>
                        ))
                    }
                </Grid>
            </>
    );
}